import { httpDeleteAdapter } from '@/lib/adapters/httpDeleteAdapter';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { authUserSchema, type AuthUser } from '@/schemas/auth-user';

export const getAuthentication = httpGetAdapter<AuthUser>({
  url: '/v2/autenticacao',
  schema: authUserSchema,
});

export const postLogout = httpDeleteAdapter({
  url: '/v2/autenticacao/cookieJwt',
});
